import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Store
import { GoPaperLessSelectors } from '@amfam/policy/go-paperless/data-access';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../../core/store';
import { GoPaperlessComponentDirective } from '../shared';

@Component({
  selector: 'app-go-paperless-promo',
  templateUrl: './go-paperless-promo.component.html',
  standalone: false
})
export class GoPaperlessPromoComponent
  extends GoPaperlessComponentDirective
  implements OnInit, OnDestroy
{
  public isEnrolled: boolean;

  // Shared subject for completing observables
  private done$: Subject<void> = new Subject<void>();

  constructor(store: Store<fromRoot.RootState>, analyticsFacade: AnalyticsFacade) {
    super(store, analyticsFacade);
  }

  enroll() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/profile'],
        query: { openAccordion: 'communication' }
      })
    );
  }

  unenroll() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies/gopaperless/unenroll']
      })
    );
  }

  ngOnInit() {
    super.ngOnInit();

    this.store
      .select(GoPaperLessSelectors.selectIsEnrolledGoPaperless)
      .pipe(takeUntil(this.done$))
      .subscribe(isEnrolled => (this.isEnrolled = isEnrolled));
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.done$.next();
    this.done$.complete();
  }
}
